import { AlertError, } from './popup';
import { TFunction, } from 'i18next';

export const deviceSetErrorCatch = (title: string, err: Error, t: TFunction) => AlertError(t, { content: title, title: err.toString().replace('NotFoundError: ', '').replace('Error: ', ''), });
